import { GetterTree } from 'vuex';
import { StateInterface } from '../index';
import { MainStateInterface } from './state';

const getters: GetterTree<MainStateInterface, StateInterface> = {
  getPage (state) {
    return state.page;
  },
  getSymbols (state) {
    return state.symbols;
  },
  getCountries (state) {
    return state.countries;
  },
  getCurrencies (state) {
    return state.currencies;
  },
  getBitflowCurrencies(state) {
    return state.bitflowCurrencies
  },
  getUser(state) {
    return state.user
  },
  accessToken(state) {
    return state.accessToken
  },
  refreshToken(state) {
    return state.refreshToken
  },
  permissions(state) {
    return state.permissions
  },
  updates(state) {
    return state.updates
  }
};

export default getters;
